import Link from 'next/link';
import { IoChevronForward } from 'react-icons/io5';

import { Anchor, Group, Stack, Text } from '@mantine/core';

import { CompanyProfile, PublishedStatus } from 'models';
import { CompanyHelpers } from 'helpers/CompanyHelpers';

import { BoothNumber } from 'components/booth-number/BoothNumber';
import { useCompanyEvent } from 'components/company-profile/hooks/use-company-event';
import { Logo } from 'components/company-profile-teaser/components/Logo';
import { useIsMobile } from 'hooks/use-is-mobile';

import cx from './CompanyHeroHeader.module.scss';

const CompanyHeroHeader = ({ company }: { company: CompanyProfile }) => {
    const { event } = useCompanyEvent(company);
    const isMobile = useIsMobile('sm');

    const isPublished = company.status === PublishedStatus.PUBLISHED;

    return (
        <Group justify="space-between" align="center" wrap="nowrap" gap="lg">
            <Group gap="sm" wrap="nowrap" miw={0}>
                <Link href={CompanyHelpers.urls.view(company.slug)} className={cx.logo}>
                    <Logo company={company} withBorder size={isMobile ? 40 : undefined} />
                </Link>
                <Stack gap={0} miw={0}>
                    <Text fw={700} lineClamp={1} className={cx.name}>
                        {company.name}
                    </Text>
                    {isPublished && (
                        <Anchor component={Link} href={CompanyHelpers.urls.view(company.slug)} className={cx.link}>
                            View profile
                            <IoChevronForward size={14} />
                        </Anchor>
                    )}
                </Stack>
            </Group>
            {event && (
                <BoothNumber
                    event={event}
                    company={company}
                    showEventName={false}
                    style={{ flexShrink: 0, whiteSpace: 'nowrap' }}
                />
            )}
        </Group>
    );
};

export { CompanyHeroHeader };
